<script setup lang="ts">
import GlobePanel from "@/globe/components/GlobePanel.vue";
import PlainLayout from "@/layouts/PlainLayout.vue";

definePage({
  meta: { layout: PlainLayout, auth: [] },
});
</script>

<template>
  <div class="fixed inset-0 h-screen w-screen overflow-hidden cursor-none">
    <GlobePanel />
  </div>
</template>
